import { Icon } from '@patternfly/react-core';

import './MenuIcon.css';

interface MenuIconProps {
    iconUri: string;
    title?: string;
    alt?: string;
    /** Size of the icon component container and icon. */
    size?: 'sm' | 'md' | 'lg' | 'xl';
    /** Size of icon. Overrides the icon size set by the size property. */
    iconSize?: 'sm' | 'md' | 'lg' | 'xl';
    /** Indicates the icon is inline and should inherit the text font size and color. Overriden by size and iconSize properties. */
    isInline?: boolean;
    height?: string;
    className?: string;
}

const MenuIcon = (props: MenuIconProps) => {
    const { iconUri, title, alt, size = 'xl', iconSize = 'xl', isInline, height, className } = props;

    const styleSize = height ? { height: height, width: height } : {};

    return (
        <Icon size={size} iconSize={iconSize} isInline={isInline} style={styleSize} className={className}>
            <span className="mv-menu-icon" title={title}><img src={iconUri} alt={alt} /></span>
        </Icon>
    );
}

export default MenuIcon;
